<template>
  <div id="left-Menu">
    <el-row>
      <el-col :span="24">
        <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          router
        >
          <template v-for="(level1, index1) in menuList">
            <el-submenu :index="index1 + ''" :key="level1.id" v-if="level1.children">
              <template slot="title">
                <i :class="[level1.icon ? level1.icon : 'el-icon-menu']"></i>
                <span>{{ level1.title }}</span>
              </template>
              <template v-for="(level2, index2) in level1.children">
                <el-menu-item
                  :index="handleUrl(level2.pathUrl)"
                  :key="level2.id"
                  v-if="!level2.children"
                >
                  <i :class="[level2.icon ? level2.icon : 'el-icon-menu']"></i>
                  <span>{{ level2.title }}</span>
                </el-menu-item>
                <el-submenu :index="index1 + '-' + index2" v-else :key="level2.id">
                  <template slot="title">{{ level2.title }}</template>
                  <template v-for="level3 in level2.children">
                    <el-menu-item :index="handleUrl(level3.pathUrl)" :key="level3.id">{{
                      level3.title
                      }}
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
            <el-menu-item :index="handleUrl(level1.pathUrl)" :key="level1.id" v-else>
              <i :class="[level1.icon ? level1.icon : 'el-icon-menu']"></i>
              <span slot="title">{{ level1.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  const panelMGMTMenuList = [
    {
      title: '会员管理',
      id: '1',
      icon: 'el-icon-s-custom',
      pathUrl: '/membersList',
    },
    {
      title: '项目管理',
      id: '2',
      icon: 'el-icon-document-copy',
      pathUrl: '/projectList',
    },
    {
      title: '互助项目',
      id: '3',
      icon: 'el-icon-help',
      pathUrl: '/mutualHelpList',
    },
    {
      title: '酬金管理',
      id: '4',
      icon: 'el-icon-coin',
      pathUrl: '/remuneration',
      children: [
        {
          title: '交易流水',
          id: '4-1',
          icon: 'el-icon-money',
          pathUrl: '/remuneration/dealFlow',
        },
        {
          title: '财务结算',
          id: '4-2',
          icon: 'el-icon-coordinate',
          pathUrl: '/remuneration/settlement',
        },
        {
          title: '项目汇总',
          id: '4-3',
          icon: 'el-icon-notebook-1',
          pathUrl: '/remuneration/summary',
        },
        {
          title: '充值记录',
          id: '4-4',
          icon: 'el-icon-notebook-2',
          pathUrl: '/remuneration/payRecords',
        },
        {
          title: '项目交易记录',
          id: '4-5',
          icon: 'el-icon-notebook-2',
          pathUrl: '/remuneration/projectTransaction',
        },
      ],
    },
    {
      title: '推广管理',
      id: '5',
      icon: 'el-icon-s-promotion',
      pathUrl: '/agent',
      children: [
        {
          title: '我的推广码',
          id: '5-1',
          icon: 'el-icon-full-screen',
          pathUrl: '/agent/myCode',
        },
        {
          title: '推广列表',
          id: '5-2',
          icon: 'el-icon-s-custom',
          pathUrl: '/agent/list',
        },
        {
          title: '用户问卷列表',
          id: '5-3',
          icon: 'el-icon-document',
          pathUrl: '/agent/questionnaireList',
        },
        {
          title: '发展专员',
          id: '5-4',
          icon: 'el-icon-s-custom',
          pathUrl: '/agent/devCommissioner',
        },
      ]
    },
    {
      title: '标签管理',
      id: '6',
      icon: 'el-icon-position',
      pathUrl: '/tagMgt',
    },
    {
      title: '合伙人管理',
      id: '7',
      icon: 'el-icon-office-building',
      pathUrl: '/enterprise',
    },
    {
      title: '管理员设置',
      id: '8',
      icon: 'el-icon-s-tools',
      pathUrl: '/manager',
    },
    {
      title: '角色权限管理',
      id: '9',
      icon: 'el-icon-s-tools',
      pathUrl: '/role',
    },
  ]
  let accMenuList = [
    {
      title: '会员管理',
      id: '2',
      icon: 'el-icon-s-custom',
      pathUrl: '/acc/membersList',
    },
    {
      title: '问卷管理',
      id: '3',
      icon: 'el-icon-document-copy',
      pathUrl: '/acc/questionnaireList',
    }
  ]
  export default {
    data() {
      return {
        menuList: [],
      }
    },
    computed: {
      onRoutes() {
        return this.$route.path
      },
    },
    created() {
      if (sessionStorage.getItem('enterpriseId') && Number(sessionStorage.getItem('enterpriseId')) > 0) {
        let enterpriseMemberRoute = {
          title: '二级合伙人管理',
          id: '1',
          icon: 'el-icon-s-custom',
          pathUrl: '/acc/enterpriseMember',
        }
        accMenuList.unshift(enterpriseMemberRoute)
      }
      this.menuList = sessionStorage.getItem('isItem') ? accMenuList : panelMGMTMenuList
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath)
      },
      handleUrl(url) {
        return `${url}`
      },
    },
  }
</script>
<style lang="scss">
  #left-Menu {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    
    .el-menu {
      border: none;
    }
  }
</style>
